import { Injectable } from '@angular/core';
import { PolicyEvent, PolicyService } from './policy.service';
import { Permission, Policy, Role } from 'src/app/global/policy-types';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
export class AuthorizationService {

    public policy: Policy | null = null;

    private rolesLoadedSubject = new BehaviorSubject<boolean>(false);
    public rolesLoaded$: Observable<boolean> = this.rolesLoadedSubject.asObservable();


    setRolesLoaded(loaded: boolean) : void{
      this.rolesLoadedSubject.next(loaded);
    }

    constructor(private policyService: PolicyService) {
      this.policyService.events.subscribe(
        PolicyEvent.PolicyLoaded,
        async () => {
          this.policy = this.policyService.currentPolicy;
        }
      );

      // In case of refresh, PolicyEvent.PolicyLoaded event will not be triggered
      // and so this.policy does not get set.
      // however because policy gets stored in localStorage during initial endpoint call
      // we can still grab it from there.
      this.policy = this.policyService.currentPolicy;
    }

    public hasPermission(permission: Permission, role? : Role) {
      if(role != undefined) {
        return this.policy?.permissions.some(o => o == permission) && this.policy.roles.some(o => o == role);
      }

      return this.policy?.permissions.some(o => o == permission);
    }

    public hasRole(role: Role) {
      return this.policy?.roles.some(o => o == role);
    }

    public isPolicyLoaded(): boolean {
      return this.hasRole(Role.Customer)! || this.hasRole(Role.CorporateAccountManager)!;
    }
}
